import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaStickyUtility from '@sparta.global.utilities/sparta-sticky-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import applyNowUtil from '@sparta.auto-loans.utilities/apply-now-utility/dist/es6.js';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-sticky-level=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyLevel") : stack1), depth0))
    + "\"";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " data-sticky-start=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyStart") : stack1), depth0))
    + "\" ";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-sticky-fade=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyFadeIn") : stack1), depth0))
    + "\" ";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-sticky-full-width=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyFullWidth") : stack1), depth0))
    + "\" ";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-sticky-end=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyEnd") : stack1), depth0))
    + "\" ";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"inner-content\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"dropdown") : depth0)) != null ? lookupProperty(stack1,"returnLink") : stack1),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":8},"end":{"line":9,"column":15}}})) != null ? stack1 : "")
    + "        <ul class=\"cta-content\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"contentSm") : depth0)) != null ? lookupProperty(stack1,"length") : stack1),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":12},"end":{"line":15,"column":19}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"contentLg") : depth0)) != null ? lookupProperty(stack1,"length") : stack1),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":12},"end":{"line":20,"column":19}}})) != null ? stack1 : "")
    + "            <li class=\"cta-content-item cta-content-item--apply-now\">\n                "
    + ((stack1 = (lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"applyNow") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":22,"column":16},"end":{"line":22,"column":41}}})) != null ? stack1 : "")
    + "\n            </li>\n            <li class=\"cta-content-item cta-content-item--contact-us\">\n                <ul class=\"spa-accordion\">\n                    <li class=\"spa-accordion-item\">\n                        <a id=\"not_ready_to_apply_online_sticky\" href=\"javascript:void(0);\"\n                            class=\"spa-accordion-link cta-link\">\n                            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"dropdown") : depth0)) != null ? lookupProperty(stack1,"header1") : stack1), depth0)) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"dropdown") : depth0)) != null ? lookupProperty(stack1,"hideChevron") : stack1),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.program(20, data, 0),"data":data,"loc":{"start":{"line":30,"column":28},"end":{"line":39,"column":35}}})) != null ? stack1 : "")
    + "                        </a>\n                    </li>\n                </ul>\n            </li>\n        </ul>\n\n        <div id=\"cta-panel\" class=\"column clearfix spa-accordion-content \">\n            <div class=\"cta-panel-content\">\n                <ul class=\"show-for-small-only accordionList\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"dropdown") : depth0)) != null ? lookupProperty(stack1,"optionsSm") : stack1),{"name":"each","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":49,"column":20},"end":{"line":55,"column":29}}})) != null ? stack1 : "")
    + "                </ul>\n                <div class=\"show-for-medium-up\">\n                    <ul class=\" accordionList\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"dropdown") : depth0)) != null ? lookupProperty(stack1,"optionsLg") : stack1),{"name":"each","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":59,"column":24},"end":{"line":65,"column":33}}})) != null ? stack1 : "")
    + "                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <button class='returnLink' onclick='history.back()'>\n            "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"dropdown") : depth0)) != null ? lookupProperty(stack1,"returnLink") : stack1), depth0)) != null ? stack1 : "")
    + "\n        </button>\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li class=\"cta-content-item cta-content-item--text show-for-small-only\">\n                <div data-font=\"cnx-regular\" aria-hidden=\"true\" id=\"smallContent\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"contentSm") || (depth0 != null ? lookupProperty(depth0,"contentSm") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"contentSm","hash":{},"data":data,"loc":{"start":{"line":13,"column":82},"end":{"line":13,"column":97}}}) : helper))) != null ? stack1 : "")
    + "</div>\n            </li>\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li class=\"cta-content-item cta-content-item--text show-for-medium-up\">\n                <div data-font=\"cnx-regular\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"contentLg") || (depth0 != null ? lookupProperty(depth0,"contentLg") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"contentLg","hash":{},"data":data,"loc":{"start":{"line":18,"column":45},"end":{"line":18,"column":60}}}) : helper))) != null ? stack1 : "")
    + "</div>\n            </li>\n";
},"18":function(container,depth0,helpers,partials,data) {
    return "";
},"20":function(container,depth0,helpers,partials,data) {
    return "                            <span id=\"ctaStickyArrowIcon\" class=\"cta-sticky-arrow-icon\">\n                                <svg focusable=\"false\" id=\"ctaDownArrow\" version=\"1.1\" width=\"15\" height=\"12\"\n                                    viewBox=\"0 0 20 12\">\n                                    <path class=\"down-arrow\" d=\"M 2,2 10,10 18,2\" fill=\"none\" stroke=\"#0052c2\"\n                                        stroke-width=\"2\" stroke-linejoin=\"miter\" stroke-linecap=\"butt\"></path>\n                                </svg>\n                            </span>\n";
},"22":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"hoverOption\">\n                        <li class=\"options\" style=\"background-image: url('"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"image") : depth0), depth0))
    + "');\">\n                            <p class=\"dropdown-text\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\n                        </li>\n                    </div>\n";
},"24":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <div class=\"hoverOption\">\n                            <li class=\"options\" style=\"background-image: url('"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"image") : depth0), depth0))
    + "');\">\n                              <p class=\"dropdown-text\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\n                            </li>\n                        </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"sticky spa-sticky secondary ada-hidden\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyLevel") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":52},"end":{"line":1,"column":127}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyStart") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":127},"end":{"line":1,"column":204}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyFadeIn") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":204},"end":{"line":1,"column":281}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyFullWidth") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":282},"end":{"line":1,"column":371}}})) != null ? stack1 : "")
    + "\ndata-sticky-parent=\"body\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyEnd") : stack1),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":25},"end":{"line":2,"column":95}}})) != null ? stack1 : "")
    + ">\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"with","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":71,"column":13}}})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.auto-loans.modules/cta-sticky-auto-module",
  "version": "2.0.0",
  "id": "ctaStickyAutoModuleJS",
  "containerID": "autoLoansCtaStickyAutoModule",
  "moduleName": "auto-loans-cta-sticky-auto-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "cta-sticky-auto-module",
  "data": {
    "init": "ctaStickyAutoModuleJS",
    "options": {
      "var1": 1
    }
  },
  "moduleParams": [{
    "name": "hideChevron",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter shows the chevron or hides it based on boolean value"
  }, {
    "name": "isSticky",
    "type": "boolean",
    "values": [true, false],
    "default": true,
    "description": "This parameter applies fixed position to title bar"
  }, {
    "name": "stickyFadeIn",
    "type": "string",
    "default": "",
    "description": ""
  }, {
    "name": "stickyFullWidth",
    "type": "boolean",
    "description": ""
  }, {
    "name": "stickyLevel",
    "type": "number",
    "values": [],
    "default": 1,
    "description": "This parameter applies fixed position to element passed by id on scroll"
  }, {
    "name": "stickyStart",
    "type": "string",
    "default": "",
    "description": ""
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        link
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    link
  },
  "dependencies": {
    "@sparta.auto-loans.utilities/apply-now-utility": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-sticky-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

const blurSticky = $el => {
  if ($el.hasClass('focused')) {
    $el.addClass('ada-hidden').removeClass('active fade-in focused');
  }
};
const focusSticky = $el => {
  if (!$el.hasClass('active')) {
    $el.removeClass('ada-hidden').addClass('active fade-in focused');
  }
};

/**
 * @export
 * @class ctaStickyAutoModuleJS
 * @extends {Module}
 */
class ctaStickyAutoModuleJS extends Module {
  /**
   * Creates an instance of ctaStickyAutoModuleJS.
   * @param {Object} options undefined
   * @param {Object} context undefiend
   * @memberof ctaStickyAutoModuleJS
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $(`#${this.id}`);
  }

  /**
   * @return {void}
   */
  init() {
    const modalIsNotOpen = $('.spa-dialog').length === 0;
    const dataStickyStartForMediumUp = 'stickytarget';
    const viewportSize = this.Store.getData('currentMQ').viewport;
    $(window).scrollTop(0);
    this.secureDomainUrlChange();

    // Grab logic for Apply Now buttons from the utility
    applyNowUtil.appendABPAurl();
    let $stickyEl;
    const dropDownLink = $('#ctaStickyArrowIcon');
    const $showHideSticky = $('.cta-link');
    const $ctaDropDown = $('#cta-panel');
    const $ctaPanel = $('#ctaStickyAutoModuleJS').find('.spa-sticky');
    const smallContent = this.settings.target.querySelector('#smallContent');
    const applyNow = this.settings.target.querySelector('#apply_now_sticky');
    const notReadyToApply = this.settings.target.querySelector('#not_ready_to_apply_online_sticky');
    // Have to set aria-hidden to true in the init
    // because LINK helper doesn't support aria attributes
    $(applyNow).attr('aria-hidden', 'true');
    $(notReadyToApply).attr('aria-hidden', 'true');

    // close dropdown if its open and the sticky gets "unstuck" or is hidden
    spartaEventsUtility.sub(spartaStickyUtility.EVENTS.ELEMENT_UNSTICK, () => {
      // TO CONSIDER: if multiple stickies exist on page...
      // you, programmer, may need to be specific in targeting
      $(smallContent).attr('aria-hidden', 'true');
      $(applyNow).attr('aria-hidden', 'true');
      $(notReadyToApply).attr('aria-hidden', 'true');
      $ctaPanel.addClass('ada-hidden').removeClass('hide');
      $ctaDropDown.css('display', 'none', '!important');
      dropDownLink.addClass('arrow-rotate-down').removeClass('arrow-rotate-up');
    });
    spartaEventsUtility.sub(spartaStickyUtility.EVENTS.ELEMENT_FADE_IN, () => {
      $ctaPanel.removeClass('ada-hidden');
      $(smallContent).removeAttr('aria-hidden');
      $(applyNow).removeAttr('aria-hidden');
      $(notReadyToApply).removeAttr('aria-hidden');
    });

    // If sticky start point has a different ID in mobile than in desktop,
    // change the data-sticky-start attribute value when viewport changes
    if (window.location.pathname === '/secure-auto-loans/' || window.location.pathname === '/secure-auto-loans/auto-refinance-loan/' || window.location.pathname === '/auto-loans/' || window.location.pathname === '/auto-loans/auto-refinance-loan/') {
      $(window).on('spartaBreakpointChange', () => {
        $stickyEl = $('.spa-sticky');
        if (viewportSize === 'small' && modalIsNotOpen) {
          spartaStickyUtility.removeStickyEls([$stickyEl]);
          if (window.location.pathname === '/secure-auto-loans/' || window.location.pathname === '/auto-loans/') {
            $stickyEl.attr('data-sticky-start', '#apply_now_small');
          } else if (window.location.pathname === '/secure-auto-loans/auto-refinance-loan/' || window.location.pathname === '/auto-loans/auto-refinance-loan/') {
            $stickyEl.attr('data-sticky-start', '#autoloan_refinance_applynow_small');
          }
          spartaStickyUtility.addStickyEls([$stickyEl]);
        }
        if (viewportSize !== 'small' && $stickyEl.attr('data-sticky-start') === '#apply_now_small' && modalIsNotOpen) {
          spartaStickyUtility.removeStickyEls([$stickyEl]);
          $stickyEl.attr('data-sticky-start', dataStickyStartForMediumUp);
          spartaStickyUtility.addStickyEls([$stickyEl]);
        }
        if (viewportSize !== 'small' && $stickyEl.attr('data-sticky-start') === '#autoloan_refinance_applynow_small' && modalIsNotOpen) {
          spartaStickyUtility.removeStickyEls([$stickyEl]);
          $stickyEl.attr('data-sticky-start', '#autoloan_refinance_applynow');
          spartaStickyUtility.addStickyEls([$stickyEl]);
        }
      });
    }
    const navToggle = function f1(e) {
      $(this).blur();
      $ctaDropDown.slideToggle(() => {
        e.preventDefault();
        if ($ctaDropDown.is(':visible')) {
          dropDownLink.removeClass('arrow-rotate-down');
          dropDownLink.addClass('arrow-rotate-up');
        } else {
          dropDownLink.removeClass('arrow-rotate-up');
          dropDownLink.addClass('arrow-rotate-down');
        }
      });
    };
    $showHideSticky.click(navToggle);
    const $stickyTitle = $('#titleModule .spa-sticky');
    const $stickyCta = $('#ctaStickyAutoModuleJS .spa-sticky');
    const $spartLayout = $('.sparta-layout');
    const hasStickyTitle = $stickyTitle.length > 0;
    let stickyBlurTimeout;
    $stickyCta.on('focus', 'a', () => {
      clearTimeout(stickyBlurTimeout);
      focusSticky($ctaPanel);
    });
    $stickyCta.on('blur', 'a', () => {
      stickyBlurTimeout = setTimeout(() => {
        blurSticky($ctaPanel);
      }, 250);
    });
    $(window).on('load', () => {
      $ctaPanel.removeClass('hide');
    });
    $(window).on('load resize scroll', _.debounce(() => {
      $stickyCta.css('width', $spartLayout.width());
      setTimeout(() => {
        $stickyCta.css('width', $spartLayout.width());
      }, 550);
      if (hasStickyTitle) {
        // eslint-disable-next-line no-mixed-operators
        if (!$stickyCta.hasClass('ada-hidden') && !$stickyTitle.is('.active') || $stickyCta.hasClass('hide')) {
          $stickyCta.addClass('ada-hidden').removeClass('hide');
        }
      }
    }, 250));

    /*
     * the following changes the domain of the schedule an appointment links to be secure domain
     * the href listed in the jcr gives a relative path,
     * so we need to change it to be secure-bankofamerica here
     * this loop catches all links with a class of 'schedule'
     * NOTE: contact us schedule an appointment link has its own logic in the contact us JS,
     * since some pages (program page) do not have sticky bar anymore
     * Keeping loop in case there are any other instances
     * of schedule link throughout site that use this
     */
    const scheduleLinks = $('.schedule');
    scheduleLinks.each(function f2() {
      const scheduleURL = $(this).attr('href');
      $(this).attr('href', spaParams.siteParams.abpaEndpoint + scheduleURL);
    });
  }

  /**
   * @return {void}
   */
  secureDomainUrlChange() {
    const updatedUrl = spaParams.siteParams.abpaEndpoint;
    $('.secureUrl').each(function f3() {
      const href = $(this).attr('href');
      $(this).attr('href', href.replace('https://secure.bankofamerica.com', updatedUrl));
    });
  }
}
registerModuleClass({
  moduleClass: ctaStickyAutoModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ctaStickyAutoModuleJS as default, moduleConfig };
